import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'

import { setXrayPanelOpen, toggleXrayPanel } from '../reducers/uiSlice.reducer'
import { persistXrayPanel } from './xrayPanelStorage'

// Side-effect host for X-ray panel persistence. Keeping this out of the
// reducer ensures the slice stays pure (Redux DevTools time-travel and
// React StrictMode double-invoke remain safe).
export const xrayPanelPersistenceMiddleware = createListenerMiddleware()

xrayPanelPersistenceMiddleware.startListening({
  matcher: isAnyOf(setXrayPanelOpen, toggleXrayPanel),
  effect: (_action, api) => {
    const state = api.getState() as { ui: { isXrayPanelOpen: boolean } }
    persistXrayPanel(state.ui.isXrayPanelOpen)
  },
})
